import { render, staticRenderFns } from "./fooeresixth.vue?vue&type=template&id=a1341c0a&scoped=true"
import script from "./fooeresixth.vue?vue&type=script&lang=js"
export * from "./fooeresixth.vue?vue&type=script&lang=js"
import style0 from "./fooeresixth.vue?vue&type=style&index=0&id=a1341c0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1341c0a",
  null
  
)

export default component.exports